var lib_core = require("lib-core");
var lib_geometry       = require("lib-geometry");

var InspectorStateMachine = function (root, model, events) {
    var self = this;
    self.root = root;

    this.model = model;
    this.delayedChangePropertyEvent = null;

    lib_core.StateMachine.call(self, null, null, model.scope());

    this.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == events.changeProperty;
        },
        function(cEvent){
            self.root.rec();
            self.changeProperty(cEvent);
            self.root.stopRec();
        }
    );

    this.addTransition("idle", "idle",  //should not happen
        function(cEvent){
            return cEvent.type() == events.enter;
        },
        function(cEvent){
            self.root.rec();
            self.applyDelayedChangeProperty();
            self.root.stopRec();
        }
    );

    this.addTransition("idle", "changing_property",
        function(cEvent){
            return cEvent.type() == events.focus;
        },
        function(cEvent){
            self.root.rec();
            self.model.focus(false);
        }
    );

    this.addTransition("changing_property", "changing_property",
        function(cEvent){
            return cEvent.type() == events.changeProperty;
        },
        function(cEvent){
            if(cEvent.data('delayChangeProperty'))
                self.delayChangeProperty(cEvent);
            else
                self.changeProperty(cEvent);
        }
    );

    this.addTransition("changing_property", "changing_property",
        function(cEvent){
            return cEvent.type() == events.enter;
        },
        function(cEvent){
            self.applyDelayedChangeProperty();
        }
    );

    this.addTransition("changing_property", "changing_property",
        function(cEvent){
            return cEvent.type() == events.focus;
        },
        function(cEvent){
            self.applyDelayedChangeProperty();
            self.root.stopRec();    // stop previous changing property
            self.root.rec();
        }
    );

    this.addTransition("changing_property", "idle",
        function(cEvent){
            return !(   cEvent.type().isHoverAction ||
                        cEvent.type().isViewAction  ||
                        cEvent.type() == events.changeProperty ||
                        cEvent.type() == events.focus ||
                        cEvent.type() == events.enter ||
                        cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_DOWN ||
                        cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_UP);
        },
        function(cEvent){
            self.applyDelayedChangeProperty();
            self.root.stopRec();
            self.model.focus(true);
            self.handle(cEvent);
        }
    );

};

lib_core.inherit(InspectorStateMachine, lib_core.StateMachine);

module.exports = InspectorStateMachine;

InspectorStateMachine.prototype.changeProperty = function(cEvent) {
    var prop = cEvent.element().collections.get(cEvent.data('id')) || cEvent.element().shadows.get(cEvent.data('id'));
    prop.set(cEvent.data('value'));
};

InspectorStateMachine.prototype.delayChangeProperty = function(cEvent) {
    console.assert(this.delayedChangePropertyEvent == null || cEvent.data('id') == this.delayedChangePropertyEvent.data('id'));
    this.delayedChangePropertyEvent = cEvent;
};
InspectorStateMachine.prototype.hasDelayedChangeProperty = function(cEvent) {
    return this.delayedChangePropertyEvent !== null;
};

InspectorStateMachine.prototype.applyDelayedChangeProperty = function() {
    if(this.delayedChangePropertyEvent)
        this.changeProperty(this.delayedChangePropertyEvent);
    this.delayedChangePropertyEvent = null;
};
